import { render, staticRenderFns } from "./participant-web-details.vue?vue&type=template&id=52c51378&scoped=true&"
import script from "./participant-web-details.vue?vue&type=script&lang=js&"
export * from "./participant-web-details.vue?vue&type=script&lang=js&"
import style0 from "./participant-web-details.vue?vue&type=style&index=0&id=52c51378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c51378",
  null
  
)

component.options.__file = "participant-web-details.vue"
export default component.exports